import React, { Component, PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  NitroLoading,
  NitroTable,
  NitroFormatter,
  NitroText,
  NitroIcon,
  NitroParagraph,
  NitroButton
} from "nitro-components";

//import { transformDataForDriverSafety } from "../DataTransformer";
import { DriverSafetyTable } from "./components";

import styled from "styled-components";

import { notify } from "../../../../components/libs/notification";

import {
  GET_TELEMATICS,
  TELEMATICS_TEXT,
  TELEMATICS_NOT_AVAILABLE
} from "./content";

const LockContainer = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 12px;
  background: ${props => props.theme.color.primary};
  text-align: center;
  padding: 1px;
  display: inline-block;
  margin-right:15px;
`;

const ButtonContainer = styled.div`
  display: inline-block;
  margin-left: 15px;
`;

class DriverSafetyTableView extends Component {
  
  sendGetTelematicsEmail = () => {
    const filters = {};
    this.props.sendGetTelematicsEmail(filters)
    this.props.notify({
            type: "success",
            title: "Telematics",
            message: "Thank you. We will get back to you shortly."
          });
     };

  render() {
    const { data, telematicsAvailable } = this.props;   

    return (
      <span>
        {telematicsAvailable &&
          <NitroParagraph header size={"3"} variant="base3" noMargin>

            <NitroIcon name="info" variant="primary" size={16} right={12} />
            {TELEMATICS_TEXT}
          </NitroParagraph>}
        {!telematicsAvailable &&
          <NitroParagraph header size={"3"} variant="base1" bold margin>
            <LockContainer>
              <NitroIcon name="lock" size={12} variant="white" />
            </LockContainer>
            {TELEMATICS_NOT_AVAILABLE}
            <ButtonContainer>
              <NitroButton
                label={GET_TELEMATICS}
                variant="primary"
                size="compact"
                action={this.sendGetTelematicsEmail}  
              />
          </ButtonContainer>
            
          </NitroParagraph>}
          
        <DriverSafetyTable
          data={data}
          openDetails={this.props.openDetails}
          telematicsAvailable={telematicsAvailable}
        />
      </span>
    );
  }
}

DriverSafetyTableView.propTypes = {
  data: PropTypes.array.isRequired,
  telematicsAvailable: PropTypes.bool,
  sendGetTelematicsEmail: PropTypes.func,
  get: PropTypes.func,
  select: PropTypes.func,
  onChange: PropTypes.func,
  save: PropTypes.func,
  notify: PropTypes.func
};

const mapDispatchToProps = dispatch => ({
  notify: bindActionCreators(notify, dispatch)
});

export default connect(null, mapDispatchToProps)(DriverSafetyTableView);



// WEBPACK FOOTER //
// ./src/features/insights/components/driverSafety/DriverSafetyTableView.js